import { useQuery } from '@tanstack/react-query'
import { useInvestDataState } from './_investDataState'

import { getAccounts, getCustodians } from '../shared/_api'
import { useLocation } from 'react-router-dom'

export const accountQueryKeyRoot = ['account'] as const

export const getAccountQueryKey = (investmentId?: string) =>
  [...accountQueryKeyRoot, investmentId] as const

export const custodiansQueryKeyRoot = ['custodians'] as const

export const getCustodiansQueryKey = (investmentId?: string) =>
  [...custodiansQueryKeyRoot, investmentId] as const

export const useAccountDataState = () => {
  const location = useLocation()
  const { data: investData } = useInvestDataState()

  return useQuery({
    queryKey: getAccountQueryKey(investData?.investment?.id),
    queryFn: async () => {
      const data = await getAccounts(investData?.investment?.id)
      return {
        ...data,
      }
    },
    enabled: !location.pathname.includes('start') || !!investData.investment,
    refetchOnWindowFocus: 'always',
    staleTime: Infinity,
  })
}

export const useCustodiansDataState = () => {
  const { data: investData } = useInvestDataState()

  return useQuery({
    queryKey: getCustodiansQueryKey(investData?.investment?.id),
    queryFn: async () => {
      const data = await getCustodians(investData?.investment?.id)
      return [...data.custodians]
    },
    refetchOnWindowFocus: 'always',
    staleTime: Infinity,
  })
}
